<template>
    <div class="single-file-alert alert">
        <div class="single-file-box alert_box">
            <h3>플레이어가 재생중일 때는 미리듣기를 재생할 수 없습니다.</h3>
            <div class="single-file-check">
                <p @click="$emit('closeAlert')">확인</p>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: 'PreferMusicAlert'
});
</script>
